<template>
  <section class="mobile-shift-summary">
    <header class="mb-5">
      <div class="overline primary--text font-weight-bold">REGISTER</div>
      <h1 class="text-h4 font-weight-bold mb-1">Shift summary</h1>
      <p class="admin-muted mb-0">Review the closing details for this shift.</p>
    </header>

    <v-progress-linear v-if="loading" indeterminate color="primary" aria-label="Loading shift summary" />

    <v-alert v-else-if="error" type="warning" outlined class="rounded-xl">
      <div class="font-weight-medium">Shift summary unavailable</div>
      <div class="text-body-2 mb-3">It may have been removed, or you may not have access to this location.</div>
      <v-btn color="primary" class="mobile-shift-summary__touch-target" @click="load">Try again</v-btn>
    </v-alert>

    <v-card v-else-if="shift" outlined class="rounded-xl elevation-0 overflow-hidden">
      <v-card-title class="d-flex align-center">
        <v-avatar color="primary" size="42" class="mr-3" aria-hidden="true"><v-icon dark>mdi-cash-multiple</v-icon></v-avatar>
        <div>
          <div>Shift #{{ shift.id }}</div>
          <div class="text-caption admin-muted text-capitalize">{{ shift.status }}</div>
        </div>
      </v-card-title>
      <v-divider />
      <v-list two-line>
        <v-list-item>
          <v-list-item-content><v-list-item-subtitle>Opened</v-list-item-subtitle><v-list-item-title>{{ dateTime(shift.openTime) }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content><v-list-item-subtitle>Closed</v-list-item-subtitle><v-list-item-title>{{ dateTime(shift.closeTime) }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content><v-list-item-subtitle>Opening balance</v-list-item-subtitle><v-list-item-title>{{ money(shift.openBalance) }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content><v-list-item-subtitle>Expected cash</v-list-item-subtitle><v-list-item-title>{{ money(shift.closeSystemCashCount) }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content><v-list-item-subtitle>Counted cash</v-list-item-subtitle><v-list-item-title>{{ money(shift.closeCashCount) }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item v-if="shift.closingStatus">
          <v-list-item-content><v-list-item-subtitle>Cash result</v-list-item-subtitle><v-list-item-title>{{ shift.closingStatus }}</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item v-if="shift.closeNote">
          <v-list-item-content><v-list-item-subtitle>Closing note</v-list-item-subtitle><v-list-item-title class="mobile-shift-summary__note">{{ shift.closeNote }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </section>
</template>

<script>
import backofficeService from "@/api/backoffice";

export default {
  name: "MobileShiftSummary",
  data: () => ({ loading: false, error: false, shift: null }),
  created() { this.load(); },
  methods: {
    async load() {
      const shiftId = String(this.$route.params.id || "").trim();
      const locationId = String(this.$route.query.locationId || "").trim();
      if (!/^\d+$/.test(shiftId) || !/^\d+$/.test(locationId)) { this.error = true; return; }
      this.loading = true;
      this.error = false;
      try {
        const response = await backofficeService.Api().get(`location/shift/${encodeURIComponent(shiftId)}`, { params: { LocationId: locationId } });
        this.shift = response.data && response.data.data;
        if (!this.shift) this.error = true;
      } catch (error) {
        this.shift = null;
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    dateTime(value) { return value ? new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "Not recorded"; },
    money(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount.toLocaleString(undefined, { style: "currency", currency: "USD" }) : "Not recorded";
    },
  },
};
</script>

<style scoped>
.mobile-shift-summary { margin: 0 auto; max-width: 760px; }
.mobile-shift-summary__note { overflow-wrap: anywhere; white-space: normal; }
.mobile-shift-summary__touch-target { min-height: 44px; }
</style>
